import styled from 'styled-components';

const Button = styled.button`
  display: ${(props) => (props.showList ? 'none' : 'flex')};
  border: none;
  background: none;
  padding: 0;
  height: 100%;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  outline: none;
  transition: transform 150ms ease-out;
  transform: ${({ isPressed }) => (isPressed ? 'scale(0.95)' : 'scale(1)')};
  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid transparent;
  }

  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    width: 100%;
  }
`;

export default Button;
